import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { TeamGrid } from '../team/TeamGrid';
export function HomeTeam() {
  return <section className="bg-white" aria-labelledby="home-team-title" data-id="element-197" data-mp="3able8srs1go3">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-198" data-mp="3a9igtnoaol9c">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-199" data-mp="35b77rf5tqes6">
          <SectionHeading id="home-team-title" eyebrow="Our Team" title="Meet Our Search Executive Partners" intro="A focused team working across executive search, professional talent sourcing and candidate engagement." data-id="element-200" data-mp="3jb8idmbw50ku" />
          <ButtonLink to="/our-team" variant="outlineDark" className="self-start lg:self-auto" data-id="element-201" data-mp="3o301jbspw40y">
            Meet Our Team
          </ButtonLink>
        </div>
        <div className="mt-14" data-id="element-202" data-mp="5vaj1at6iiae">
          <TeamGrid compact data-id="element-203" data-mp="1wl7lnrpbate" />
        </div>
      </div>
    </section>;
}